export var smoothScrollIntoView = function smoothScrollIntoView(block) {
  var marginTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  try {
    window.scrollTo({
      /** Делаем небольшой отступ между верхом вьюпорта и блоком */
      top: block.offsetTop - marginTop,
      left: 0,
      behavior: 'smooth'
    });
  } catch (e) {
    window.scrollTo(0, block.offsetTop - marginTop);
  }
};